import React from 'react';

import {Helpers} from '../../core';
import JsonLd from '../../shared/components/json-ld';

const getProductJsonLdImageData = (image) => image ? (image.cdn || image.lrg || image.sm || image.src) : null;
const getProductJsonLdImageArrayData = (images) => images instanceof Array ? ({
  image: images.map( img => getProductJsonLdImageData(img) )
}) : null;

const getProductJsonLdBrand = ({brand, facet_subbrand})=> (brand || facet_subbrand) && ({
  brand: {
    "@type": "Thing",
    name: brand || facet_subbrand
   }
 })

 const getProductJsonLdRatings = (rating, numReviews) => {
  let ratingValue, reviewCount;

  // if rating is an object, get the score and number of reviews from it
  if(rating && typeof rating === 'object'){
    let {score, reviewsCount} = rating;
    ratingValue = score;
    reviewCount = typeof reviewsCount === 'number' ? reviewsCount : numReviews;
  }
  else{
    ratingValue = rating;
    reviewCount = numReviews;
  }
  return !isNaN(ratingValue) && !isNaN(reviewCount) && reviewCount > 0 && ({
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue,
      reviewCount
    }
  })
};

 const getProductJsonLdOffers = ({linkUrl, productUrl, instock, salePrice, listPrice, isOOS, price}) => {
   let url = linkUrl || productUrl; // linkUrl is the old field in mongo collection, productUrl is from ETR API
   if(typeof url == 'string' && /^\//.test(url)){
     url = Helpers.getAbsoluteRedirectPath(url);
   }

   let jsonLdPrice = price && price.salePrice
                     ? price.salePrice
                     : price && price.regularPrice
                     ? price.regularPrice 
                     : salePrice || listPrice;

   return jsonLdPrice && ({
      "offers": {
        "@type": "Offer",
        "priceCurrency": "USD",
        price: jsonLdPrice,
        ...url && { url },
        ...([typeof instock, typeof isOOS].includes('boolean')) && { availability: instock || isOOS === false ? "https://schema.org/InStock" : "https://schema.org/OutOfStock" }
      }
    })
};

 // note: products from swiftype have a slightly different syntax.
 // For example, prdOverview would be in the root of the product rather than in the attributes field
 const getProductJsonLdData = ({name, images, sku, rating, numReviews, upc, brand, facet_subbrand, listPrice, salePrice, attributes, prdOverview, linkUrl, productUrl, instock, isOOS, price}) => {
   const { prdOverview : attributeProductOverview } = attributes || {};
   const jsonLdData = {
     "@context": "https://schema.org/",
     "@type": "Product",
     "name": name,
     "sku": sku,
     "mpn": sku,
     ...((upc && {gtin: upc }) || {}),
     ...(attributeProductOverview || prdOverview) && { "description": attributeProductOverview || prdOverview },
     ...getProductJsonLdImageArrayData(images),
     ...getProductJsonLdBrand({ brand, facet_subbrand}),
     ...getProductJsonLdRatings(rating, numReviews),
     ...getProductJsonLdOffers({ instock, isOOS, linkUrl, productUrl, salePrice, listPrice, price })
   }
   return jsonLdData;
 }

 export default ({product, price}) => ( product && product.name && product.images && product.sku ) && ( (price && (price.salePrice || price.regularPrice)) || product.salePrice || product.listPrice) ? (
   <JsonLd type="product" data={getProductJsonLdData({...product, price})} shouldNotUseDefaults={true} />
 ) : null;
